import { makeAutoObservable, observable, runInAction } from 'mobx';
import UserModel from '../../models/UserModel';
import backendStorage from '../../storages/external/backend';
import { API_USER_UPLOAD_AVATAR } from '../../services/apiPoints';
import { requestGet } from '../../services/real.backend';

class UsersStorage {
  users = [];

  selectedRows = [];

  toggleCleared = false;

  isRequestProgress = true;

  isUserSaveRequestProgress = false;

  currentUser = null;

  currentChanges = {};

  filter = [
    {
      field: 'id',
      operation: '<',
      value: 5,
      ready: false,
    },
  ];

  settings = {};

  texts = {};

  addPhotoDialogOpened = false;

  saveUsersChanges = () => {
    this.isUserSaveRequestProgress = true;
    backendStorage.saveUsers(this.currentChanges);
  };

  createUser = () => {
    this.isUserSaveRequestProgress = true;
    const newUser = new UserModel();
    newUser.setUserId(-1);
    this.users = [newUser, ...this.users];
    this.changeUserField(-1, 'id', -1);
    this.setCurrentUser(-1);
    // backendStorage.createUser({});
  };

  saveUserAvatar = () => {};

  getUploadParams = ({ meta }, ...rest) => ({ url: API_USER_UPLOAD_AVATAR.replace('{uid}', this.currentUser) })

  handleChangeStatus = (req, status, resp) => {
    if (status === 'done') {
      const response = JSON.parse(resp[0].xhr.response);
      if (response && response.users) {
        response.users.map((user) => {
          const userIndex = this.users.findIndex((item) => user.id == item.id);
          const updatedUser = new UserModel(user);
          if (userIndex >= 0) {
            this.users[userIndex].avatar = user.avatar;
          } else {
            this.users.push(updatedUser);
          }
        });
      }
    }
  }

  loadSettings = () => requestGet('/api/settings')
    .then((resp) => {
      if (resp.status === 'success') {
        runInAction(() => {
          this.settings = {};
          resp.settings.forEach((item) => {
            this.settings[item.name] = { value: item.value, type: item.type };
          });
        });
      }
    });

  get haveChanges() {
    return Object.keys(this.currentChanges).length > 0;
  }

  get selectedUser() {
    const users = this.users.filter((u) => u.id === this.currentUser);
    if (users.length > 0) {
      return users[0];
    }
    return {};
  }

  get getUsers() {
    const { users, filter } = this;
    const currentFilters = filter;
    // const currentFilters = {};
    // filter.map((filter) => {
    //   if (filter.ready) {
    //     if (!currentFilters[filter.field]) currentFilters[filter.field] = [];
    //     currentFilters[filter.field].push(filter);
    //   }
    // });
    const currentUsers = users.filter((user) => {
      const allow = currentFilters.reduce((allowed, filter) => {
        if (!filter.ready) return allowed;
        if (!allowed) return allowed;
        const value = user[filter.field];
        switch (filter.operation) {
          case '>':
            return value > filter.value;
          case '<':
            return value < filter.value;
          case '=':
            return value == filter.value;
          default:
            return allowed;
        }
      }, true);
      return allow;
    });
    return currentUsers;
  }

  constructor() {
    makeAutoObservable(this);
    // this.users.push(new UserModel());
    // this.users.push(new UserModel());
  }

  handleRowSelected = (selected) => {
    this.selectedRows = selected.selectedRows;
  }

  setToggleCleared = (b) => {

  }

  deleteSelected = () => {

  }

  createFilter = () => {
    this.filter.push({
      field: 'id',
      operation: '<',
      value: 0,
      ready: false,
    });
  }

  loadDataFromServer = () => {
    // this.isRequestProgress = true;
    backendStorage.getUsers();
  }

  changeFilter = (index, field, value) => {
    this.filter[index][field] = value;
  }

  setCurrentUser = (id) => {
    this.currentUser = this.currentUser === id ? null : id;
  }

  changeUserField = (id, field, value) => {
    const index = this.users.findIndex((u) => u.id === id);
    const user = { ...this.users[index], [field]: value };
    this.users[index] = user;
    this.users = [...this.users];
    if (!this.currentChanges[user.id]) this.currentChanges[user.id] = {};
    this.currentChanges[user.id][field] = value;
  }

  deleteUser = (id) => {
    backendStorage.deleteUser(id);
  }

  restoreUser = (id) => {
    backendStorage.restoreUser(id);
  }

  unbanUser = (id) => {
    this.isUserSaveRequestProgress = true;
    const index = this.findUser(id);
    if (index >= 0) {
      this.users[index].status = 0;
      backendStorage.saveUsers({ [id]: { status: 0 } });
    }
  }

  banUser = (id) => {
    this.isUserSaveRequestProgress = true;
    const index = this.findUser(id);
    if (index >= 0) {
      this.users[index].status = -1;
      backendStorage.saveUsers({ [id]: { status: -1 } });
    }
  }

  findUser = (id) => this.users.findIndex((user) => user.id == id)

  getUserByID = (id) => {
    const userIndex = this.users.findIndex((user) => user.id == id);
    if (userIndex >= 0) {
      return this.users[userIndex];
    }
    const unknownUser = new UserModel();
  }

  toggleAddPhotoDialog = () => {
    this.addPhotoDialogOpened = !this.addPhotoDialogOpened;
  }

  changeSettings = (settings) => {
    console.log(settings);
    settings.forEach((item) => {
      this.settings[item.name] = { value: item.value, type: item.type };
    });
    this.settings = { ...this.settings };
  }
}

const usersStorage = new UsersStorage();

export default usersStorage;
